const env = typeof window.source !== 'undefined' ? window.source.env : 'local';
let envID = 'd0d4673638e28d315caef9283e933c6d';
let envURL = 'shop-dev.hachettebookgroup.com';

if (env === 'production') {
              envID = "168491a92b57aa22c6202f9884bbba90",
              envURL = 'shop.hachettebookgroup.com'
} else if (env === 'preprod') {
              envID = "168491a92b57aa22c6202f9884bbba90",
              envURL = 'shop.hachettebookgroup.com'
}

export default {envID, envURL, env};